<script lang="ts">
import { defineComponent } from 'vue'
export default defineComponent({
  name: "commonDialog",
  
})
</script>
<template>
    <van-overlay :show="showed" :lock-scroll="lockScroll" v-bind="$attrs" @click="handleOverlayClose" :z-index="zIndex">
        <div class="dialog" @click.stop>
            <div :class="['dialog-head', { active: showLine }]">
                <slot v-if="$slots.head" name="head"></slot>
                <p class="text-center" v-else>{{ $t(title) }}</p>
                <div v-if="showClose" class="close-icon" @click="handleClose">
                    <van-icon name="cross" color="#8E80A8" />
                </div>
            </div>
            <div class="dialog-content">
                <slot></slot>
            </div>
        </div>
    </van-overlay>
</template>
<script lang="ts" setup name="commonDialog">
const props = defineProps({
    zIndex: {
        type: [Number, String],
        default: () => 2001,
    },
    modelValue: {
        type: Boolean,
        default: () => false,
    },
    showClose: {
        type: Boolean,
        default: () => true,
    },
    lockScroll: {
        type: Boolean,
        default: () => false,
    },
    lockBodyScroll: {
        type: Boolean,
        default: () => true,
    },
    title: {
        type: String,
        default: () => '',
    },
    closeOnClickOverlay: {
        type: Boolean,
        default: () => true,
    },
    showLine: {
        type: Boolean,
        default: () => true,
    },
})

const emits = defineEmits(['close', 'update:modelValue'])
const showed = defineModel<boolean>()

const handleOverlayClose = () => {
    if (props.closeOnClickOverlay) {
        handleClose()
    }
}

const handleClose = () => {
    showed.value = false
    emits('close')
}

const bodyScrollType = computed(() => (props.lockBodyScroll ? 'hidden' : 'auto'))
</script>
<style scoped lang="scss">
.dialog {
    @apply flex flex-col;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 684px;
    // max-height: 65vh;
    background: #2f213b;
    background-blend-mode: normal, normal;
    border-radius: 30px;

    transform: translate3d(-50%, -50%, 0);
}
.dialog-head {
    position: relative;
    height: 96px;
    font-size: 34px;
    font-weight: 700;
    color: #ffffff;
    display: flex;
    align-items: center;
    justify-content: center;
    &.active {
        &::after {
            position: absolute;
            bottom: 5px;
            left: 50%;
            content: '';
            width: 620px;
            height: 4px;
            background-color: #ffffff;
            border-radius: 2px;
            opacity: 0.2;

            transform: translate3d(-50%, 0, 0);
        }
    }
    p {
        padding-top: 14px;
    }
}
.dialog-content {
    flex: 1;
    overflow: v-bind(bodyScrollType);
}
.close-icon {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 22px;
    width: 56px;
    height: 56px;
    padding: 12px 10px 10px 12px;
    background: #382b4a;
    border-radius: 12px;
}
</style>
